import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBroker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M16.243 14.29c0-.433.352-.785.785-.785h3.426a.786.786 0 1 1 0 1.572h-3.426a.786.786 0 0 1-.785-.786Z"
    />
    <path
      fill="#F7A600"
      d="M5.148 7.502c0-.434.352-.786.786-.786h3.882a.786.786 0 1 1 0 1.571H5.934a.786.786 0 0 1-.786-.785ZM3.79 14.642a.786.786 0 0 1 1.11-.02l6.35 6.112.01.01c.16.16.404.153.55.005l.004-.005a.386.386 0 0 0 .005-.55l-.005-.004-1.304-1.304a.786.786 0 0 1 1.111-1.112l1.302 1.303c.776.765.77 2.01.005 2.776a1.957 1.957 0 0 1-2.774.008l-6.343-6.108a.786.786 0 0 1-.021-1.11Z"
    />
    <path
      fill="#F7A600"
      d="M12.325 16.249a.786.786 0 0 1 1.112 0l2.019 2.02c.765.764.822 2.015.034 2.805-.786.797-2.049.733-2.81-.029l-2.02-2.02a.786.786 0 0 1 1.111-1.11l2.02 2.019c.195.195.455.164.58.036l.005-.005c.137-.136.162-.393-.031-.586l-2.02-2.019a.786.786 0 0 1 0-1.111Z"
    />
    <path
      fill="#F7A600"
      d="M13.891 14.453a.786.786 0 0 1 1.112.007l1.994 2.017c.766.768.73 1.993-.023 2.75-.753.762-1.99.79-2.756.025l-2.011-2.011a.786.786 0 0 1 1.11-1.111l2.012 2.011c.13.13.367.143.527-.019l.004-.004c.171-.171.151-.404.024-.531l-.003-.004-1.996-2.019a.786.786 0 0 1 .006-1.111Z"
    />
    <path
      fill="#F7A600"
      d="M12.435 9.696a.786.786 0 0 1 1.111 0l5.115 5.115c.766.766.76 2.002-.007 2.77l-.005.004c-.76.747-1.992.775-2.765.003l-1.925-1.925a.786.786 0 0 1 1.112-1.111l1.925 1.925a.39.39 0 0 0 .549-.01c.157-.16.15-.4.005-.545l-5.115-5.115a.786.786 0 0 1 0-1.11Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M10.11 6.144a.786.786 0 0 1 .539-.214h7.857a.786.786 0 0 1 0 1.572H10.96L8.51 9.809c-.333.34-.318.88-.05 1.15.288.282.836.288 1.17-.045l2.035-2.035a.786.786 0 0 1 1.115.004l1.964 1.996a.786.786 0 1 1-1.12 1.102l-1.408-1.43-1.475 1.474c-.892.892-2.432.993-3.386.05l-.004-.003c-.954-.954-.83-2.497.055-3.382a.8.8 0 0 1 .017-.016l2.687-2.53Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M19.478 5.93h2.956a.786.786 0 1 0 0-1.571h-3.442c-.732 0-1.32.671-1.152 1.425l2.254 10.525a.786.786 0 0 0 1.537-.33L19.478 5.93Z"
    />
    <path
      fill="#F7A600"
      d="M1.22 5.93c0-.434.352-.786.785-.786h3.05c.726 0 1.309.661 1.155 1.407L4.35 17.152a.786.786 0 0 1-1.547-.271L4.586 6.716h-2.58a.786.786 0 0 1-.786-.786ZM21.648 8.287a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.79 9.073a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571Z"
    />
  </svg>
);
export default SvgTwoColorBroker;
